module.exports = __webpack_public_path__ + "img/aboutRobotArm.44900748.png";